import React, { Fragment, ReactNode, CSSProperties } from 'react';

import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import { basicDropShadow, boxWithShadowStyle } from '../../assets/theme/muitheme';
import { PlainObject } from '../data_types/types';


interface CompProps {
    center?: boolean,
    header?: ReactNode;
    subHeader?: ReactNode;
    headerSx?: CSSProperties;
    bodySx?: CSSProperties | PlainObject;
    wrapperSx?: CSSProperties;
    gridItemProps?: PlainObject;
    children: ReactNode;
};


const StyledGridItemWithHeader:React.FC<CompProps> = ({
    center,
    header,
    subHeader,
    headerSx = {},
    bodySx = {},
    wrapperSx = {},
    gridItemProps,
    children
})=> (
    <Grid item { ...gridItemProps } sx={{ maxWidth: '100%' }}>
        <Paper elevation={0} square={false} sx={{ ...boxWithShadowStyle, ...wrapperSx }}>
            {
                header &&
                    <Typography
                        variant="subtitle1"
                        component="div"
                        sx={{
                            padding: '10px 15px',
                            backgroundColor: 'transparent',
                            boxShadow: basicDropShadow,
                            textAlign: center ? 'center' : 'left',
                            ...headerSx
                        }}
                    >
                        { header }
                        {
                            subHeader &&
                                <Fragment>
                                    <br /> <Box sx={{ color: theme => theme.palette.text.secondary, fontSize: '14px' }}>{subHeader}</Box>
                                </Fragment>
                        }
                    </Typography>
            }

            <Box
                className="paper-wrapper-body"
                sx={{
                    padding: '10px',
                    textAlign: center ? 'center' : 'left',
                    ...bodySx
                }}
            >
                { children }
            </Box>
        </Paper>
    </Grid>
);

export default StyledGridItemWithHeader;
